import stylesheet from './CarouselPagination.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import '../../parts/icon/icon';

type Direction = 'prev' | 'next';

const BREAKPOINTS = ['md', 'lg', 'xl', 'xxl'];

class NXTCarouselPagination extends CustomComponent {
    static observedAttributes = ['has-prev', 'has-next'];

    private prevButton: HTMLButtonElement;
    private nextButton: HTMLButtonElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get size(): string {
        return this.getAttribute('size') ?? 'md';
    }

    getBreakpointSizeClasses(): string[] {
        const classes: string[] = [];
        for (const breakpoint of BREAKPOINTS) {
            const attribute = `size-${breakpoint}`;
            if (this.hasAttribute(attribute)) {
                classes.push(`carousel-pagination-${this.getAttribute(attribute)}-${breakpoint}-up`);
            }
        }
        return classes;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            'carousel-pagination',
            `carousel-pagination-${this.size}`,
            ...this.getBreakpointSizeClasses(),
        );
        if (this.hasAttribute('counter-hide-md')) {
            container.classList.add('carousel-pagination-hide-counter-md');
        }
        container.innerHTML = `
            <button type="button" class="btn btn-prev">
                <nxt-icon icon="chevron-left"></nxt-icon>
            </button>
            <div class="counter"><slot></slot></div>
            <button type="button" class="btn btn-next">
                <nxt-icon icon="chevron-right"></nxt-icon>
            </button>
        `;

        this.prevButton = container.querySelector('.btn-prev');
        this.nextButton = container.querySelector('.btn-next');

        this.prevButton.addEventListener('click', () => this.emit('prev'));
        this.nextButton.addEventListener('click', () => this.emit('next'));

        this.updateDisabled();
        return container;
    }

    // noinspection JSUnusedGlobalSymbols
    attributeChangedCallback(name: string) {
        if (!this.isAttached) return;
        if (name === 'has-prev' || name === 'has-next') {
            this.updateDisabled();
        }
    }

    private updateDisabled() {
        this.prevButton.disabled = !this.hasAttribute('has-prev');
        this.nextButton.disabled = !this.hasAttribute('has-next');
    }

    private emit(direction: Direction) {
        this.dispatchEvent(new CustomEvent(`carousel-${direction}`, { bubbles: true }));
    }
}

customElements.define('nxt-carousel-pagination', NXTCarouselPagination);
